<div class="row productLabelFormPage">
  <div class="mainContent">

    <div class="row justify-content-between align-items-center py-2 m-0 mt-1">
        <h3 *ngIf="isUpdateRequest">
          Update Seed Reservation
        </h3>
        <h3 *ngIf="!isUpdateRequest">
          Seed Reservation Confirmation - {{headerId}}
        </h3>
        <button *ngIf="!readOnlyAccess" class="btns createReservation" mat-raised-button color="primary" (click)="navigateToCreate()">
          Create New Reservation
        </button>
    </div>
    <div class="OrderReleaseTop" *ngIf="reservationData">

      <div class="row">
        <div class="col-md-4 withBordr productLabelAccountName pb-3 pb-md-0">

          <h3 class="headerContent">Account:</h3>
          <div class="col-md-12 p-0">
            <h4 class="name greenColor">
              {{reservationData.shipToName}}
            </h4>
            <p class="address m-0">
              {{reservationData.shipToAccountAddress1}},  {{reservationData.shipToAccountAddress1}}, {{reservationData.shipToState}} - {{reservationData.shipToZipCode}}
            </p>
            <p class="phoneNo m-0">
              {{reservationData.shipToContact}}
            </p>
            <p class="grower-nos m-0">
              <span class="grower-gln">
                Account #: {{reservationData.shipTo}}
              </span>
            </p>
          </div>

        </div>

        <div class="col-md-4 material-select withBordr productLabelAccountName pb-3 pb-md-0">
          <h3 class="headerContent">Seller:</h3>
          <div class="col-md-12 p-0">
            <h4 class="name greenColor">
              {{reservationData.salesRepresentativeAccountName}}
            </h4>
            <p class="phoneNo m-0">
              {{reservationData.salesRepresentativeContact}}
            </p>
            <p class="grower-nos m-0">
              <span class="email">
                {{reservationData.salesRepresentativeEmail}}
              </span>
            </p>
          </div>
        </div>
        <div class="col-md-4 material-select withBordr productLabelAccountName">
          <h3 class="headerContent">Grower:</h3>
          <div class="col-md-12 p-0">
            <h4 class="name greenColor">
              {{reservationData.growerName}}
            </h4>
            <p class="grower-nos m-0">
              <span class="grower-gln">
                Retail Account ID: {{reservationData.retailAccountId}}
              </span>
            </p>
            <h4 class="name greenColor">
              {{reservationData.retaileAccountName}}
            </h4>
            <p class="grower-nos m-0">
              <span class="grower-gln">
                Email: {{reservationData.retailerEmail}}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center flex-md-row flex-column-reverse">
    <div class="productsection d-flex align-items-center" [ngStyle]="!readOnlyAccess && selectedCount > 0 ? {'visibility': 'visible'} : {'visibility': 'hidden'}">
      <div class="col-md-2 d-flex align-items-center">
        <mat-checkbox #Allcheck class="custom-checkbox select-all-check mt-0"
                      [checked]="dataSource.length > 0 && (selectedCount > 0) && (selectedCount == dataSource.length)"
                      [indeterminate]="dataSource.length > 0 && (selectedCount > 0) && (selectedCount < dataSource.length)"
                      [style.display]="readOnlyAccess ? 'none' : ''"
                      (change)="enableAllCheckBoxes(Allcheck._checked);"
                      matTooltip="Select All Items" [matTooltipPosition]="'above'"
                      data-testid="ddl-select-all-product"></mat-checkbox>

        <div class="product-tools-outer" *ngIf="showTabs">
          <div class="product-tools-tab" appClickOutside (clickOutside)="tabNode=''">

            <div class="tab-bar margin-l15 col-md-10">
              <ul>
                <li (click)="tabNode='delete'" class="seperator" matTooltip="Delete Items from Reservation" [matTooltipPosition]="'above'">
                  <i class="icon-ico-trash"></i>
                </li>
              </ul>
            </div>

            <div class="tab-content">
              <div *ngIf="tabNode==='delete'" class="delete-product">
                <div class="tab-content-heading">
                  Delete Items from Reservation
                </div>
                <div class="tab-content-detail">
                  <p>Are you sure you want to delete <span> {{selectedCount}} </span> selected Items(s)?</p>
                  <div class="btn-area">
                    <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="deleteSelectedItems(true)">Yes</button>
                    <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="deleteSelectedItems(false)">No</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="btns addReservation" *ngIf="isUpdateRequest && !readOnlyAccess" mat-raised-button color="primary" (click)="addReservationRow()">
      Add Reservation
    </button>
    <button class="btns addReservation" *ngIf="!isUpdateRequest" mat-raised-button color="primary" (click)="downloadPDF()">
      Download PDF
    </button>
  </div>
    <div class="tableOuterContainer">
      <table mat-table [dataSource]="dataSource" class="productTable matTables seedReservationTable">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>  </th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox #SingleCheck class="custom-checkbox"
                          [style.display]="'contents'"
                          [disabled]="(readOnlyAccess || !element.isEditable) && (!element.newLine)"
                          [hidden]="!isUpdateRequest"
                          (change)="enableCheckBoxSingle(SingleCheck._checked)"
                          [(ngModel)]="element.selected"
                          [attr.data-testid]="'ddl-specific-check_'+i"></mat-checkbox>
          </td>
          <td mat-footer-cell *matFooterCellDef> </td>
        </ng-container>

        <ng-container matColumnDef="productLine">
          <th mat-header-cell *matHeaderCellDef> Product Line </th>
          <td mat-cell *matCellDef="let element">

            <p class="d-block d-md-none fontSize mb-2">Product Line</p>
            <!-- If productLineName exists -->
            <span *ngIf="element.productLineName && element.marketingBrandName">
              {{ element.productLineName }}
            </span>

            <!-- If productLineName does NOT exist -->
            <ng-select *ngIf="!element.productLineName"
                       [items]="productList"
                       class="custom-select-grower grower-add-drop productLabelDropdown"
                       [virtualScroll]="true"
                       bindLabel="value"
                       [disabled]="readOnlyAccess"
                       bindValue="id"
                       [placeholder]="element.productLineId ? '' : 'Select Product Line'"
                       [(ngModel)]="element.productLineId"
                       [closeOnSelect]="true"
                       [searchFn]="filterSearchFn"
                       (change)="onProductOrBrandChange(element, 'productLine')">
            </ng-select>
            <div *ngIf="element.hasProductLineError" class="text-danger large">
              Please select Product Line
            </div>
          </td>

        </ng-container>
        <ng-container matColumnDef="marketingBrand">
          <th mat-header-cell *matHeaderCellDef> Marketing Brand </th>
          <td mat-cell *matCellDef="let element">

            <p class="d-block d-md-none fontSize mb-2">Marketing Brand</p>

            <span *ngIf="element.marketingBrandName && element.productLineName">
              {{ element.marketingBrandName }}
            </span>


            <ng-select *ngIf="!element.marketingBrandName"
                       [items]="element.marketingBrandFilteredList"
                       class="custom-select-grower grower-add-drop productLabelDropdown"
                       [virtualScroll]="true"
                       bindLabel="value"
                       [disabled]="readOnlyAccess || !element.productLineId"
                       bindValue="id"
                       [placeholder]="element.marketingBrandId ? '' : 'Select Marketing Brand'"
                       [(ngModel)]="element.marketingBrandId"
                       [closeOnSelect]="true"
                       [searchFn]="filterSearchFn"
                       (change)="onProductOrBrandChange(element, 'marketingBrand')">
            </ng-select>
            <div *ngIf="element.hasMarketingBrandError" class="text-danger large">
              Please select Marketing Brand
            </div>

          </td>
        </ng-container>

        <ng-container matColumnDef="labelQty">
          <th mat-header-cell *matHeaderCellDef> Units </th>
          <td mat-cell *matCellDef="let element">
            <p class="d-block d-md-none fontSize mb-2">Units </p>

            <div *ngIf="!element.hasError">
              <button *ngIf="isUpdateRequest && (element.newLine || element.selected)" (click)="geuValueChange('decrease',element);" class="plus-minus-btn minusBtn" [attr.data-testid]="'decrease-' + element.productName"> - </button>
              <input [readonly]="readOnlyAccess || (!element.newLine && !element.selected)" type="text" class="geu-txt decimal-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element)" [(ngModel)]="element.quantity" maxlength="6" appNumbersOnly [attr.data-testid]="'txt-specific-qty_'+i" />
              <button *ngIf="isUpdateRequest && (element.newLine || element.selected)" (click)="geuValueChange('increase',element)" class="plus-minus-btn plusBtn" [attr.data-testid]="'increase-' + element.productName"> + </button>
            </div>
            <div *ngIf="element.hasError" class="text-danger large">
              {{ element.errorMessage }}
            </div>
          </td>
        </ng-container>

        <!--Enter product Name Row-->


        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>

  <div class="SeedFulfillBtnSec">

    <div class="row d-flex align-items-center flex-md-row flex-column-reverse">
      <div class="col-md-8 col-12 p-1 d-flex d-md-block">
        <button mat-raised-button *ngIf="!readOnlyAccess && isUpdateRequest" class="btns updateReservation mobileView" (click)="saveOrder()" [style.display]="'inline-block'" [disabled]="!isFormValid() || readOnlyAccess || isPlaceOrderDisable || hasAnyError()">Update Reservation</button>
        <button mat-raised-button *ngIf="isUpdateRequest"  class="btns updateReservation w140" color="primary" (click)="navigateTolandingPage()">Cancel</button>
        <button mat-raised-button *ngIf="!isUpdateRequest"  class="btns backBtn" color="primary" (click)="navigateTolandingPage()">Back To Reservation List</button>
      </div>
      <div class="col-md-4 col-12 text-md-right text-center mb-md-0 mb-2" *ngIf="isUpdateRequest">
        SEED RESERVATION SELECTED <span class="dataCount">{{dataCount}}</span>
      </div>
    </div>
  </div>
</div>
